import React from 'react';
import { List, Table, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { RedTimes, TableView, TitleTag } from '~/stylizations/styles';
import { formatPrice, parsePrice } from '~/Utils/format';

export default function FinancialClosingPayAndLoss({ values, isMobile }) {
  const { t } = useTranslation();

  const label = (text) => <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t(text)}</span>;
  const mobileLabel = (text) => (
    <div>
      <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{t(text)}</span>
    </div>
  );
  const child = (text) => {
    if (text == null || text == '') {
      return (
        <div style={{ textAlign: 'center' }}>
          <RedTimes />
        </div>
      );
    }

    return <span style={{ fontSize: isMobile ? '12px' : '15px', fontWeight: 'bold' }}>{t(`${text}`)}</span>;
  };

  const paymentsFields = (values?.event_financial_payments?.length ? values.event_financial_payments : [{}]).flatMap(
    (payment, i) => [
      { label: `Pagamento ${i + 1} - Nome`, value: payment?.name },
      { label: `Pagamento ${i + 1} - Valor`, value: payment?.price },
    ]
  );

  const lossesFields = (values?.event_financial_losses?.length ? values.event_financial_losses : [{}]).flatMap(
    (loss, i) => [
      { label: `Pagamento ${i + 1} - Nome`, value: loss?.name },
      { label: `Pagamento ${i + 1} - Valor`, value: loss?.price },
    ]
  );

  const data = [...paymentsFields, ...lossesFields];

  const totalPayments = values.event_financial_payments?.reduce((acc, p) => {
    const price = parsePrice(p.price);
    return acc + price;
  }, 0);

  const totalLosses = values.event_financial_losses?.reduce((acc, l) => {
    const price = parsePrice(l.price);
    return acc + price;
  }, 0);

  return isMobile ? (
    <List
      bordered
      dataSource={data}
      renderItem={({ label, value }) => (
        <List.Item>
          <Typography.Text strong>{mobileLabel(label)}</Typography.Text>
          {child(value)}
        </List.Item>
      )}
    />
  ) : (
    <>
      <TitleTag>{label('PAGAMENTOS')}</TitleTag>
      <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={[
          {
            title: label('Descrição'),
            dataIndex: 'name',
            render: child,
          },
          {
            title: label('Valor'),
            dataIndex: 'price',
            render: child,
          },
        ]}
        dataSource={values.event_financial_payments}
        summary={() => {
          return (
            <Table.Summary.Row style={{ backgroundColor: '#d6d6d6' }}>
              <Table.Summary.Cell>{t('TOTAL')}</Table.Summary.Cell>
              <Table.Summary.Cell>{formatPrice(totalPayments)}</Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
      <TitleTag>{label('SOBRA/FALTA')}</TitleTag>
      <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={[
          {
            title: label('Descrição'),
            dataIndex: 'name',
            render: child,
          },
          {
            title: label('Valor'),
            dataIndex: 'price',
            render: child,
          },
        ]}
        dataSource={values.event_financial_losses}
        summary={() => {
          return (
            <Table.Summary.Row style={{ backgroundColor: '#d6d6d6' }}>
              <Table.Summary.Cell>{t('TOTAL')}</Table.Summary.Cell>
              <Table.Summary.Cell>{formatPrice(totalLosses)}</Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
    </>
  );
}
